import {
  type MantineStyleProps,
  Table as MantineTable,
  type TableProps,
} from "@mantine/core";

type Props = TableProps & MantineStyleProps;

export function Table(props: Props) {
  const { children, ...tableProps } = props;
  const defaultOption: Omit<TableProps, "children"> = {
    striped: true,
    verticalSpacing: "md",
    fz: "md",
    horizontalSpacing: "md",
  };
  const option = Object.assign({}, defaultOption, tableProps);
  return <MantineTable {...option}>{children}</MantineTable>;
}
